module.exports = __webpack_public_path__ + "static/top-element.8c78fd0f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/complex/Splash/scene-elements/top-element.svg
// module id = 320
// module chunks = 35783957827783